export default {
  // Basic info
  'agents.title': 'Agentes',
  'agents.tab.ai': 'IA',
  'agents.tab.rpa': 'RPA',
  'agents.tab.skills': 'Skills',

  // AI Provider options (for filters and forms)
  'agents.ai.provider.openai': 'OpenAI',

  // RPA Platform options (for filters and forms)
  'agents.rpa.platform.windows': 'Windows',
  'agents.rpa.platform.android': 'Android',

  // RPA effective status (derived from isActive + current session)
  'agents.rpa.status.unknown': 'Desconocido',
  'agents.rpa.status.online': 'En línea',
  'agents.rpa.status.offline': 'Sin conexión',
  'agents.rpa.status.disabled': 'Desactivado',
  'agents.rpa.status.unlinked': 'Sin equipo vinculado',
  'agents.rpa.status.created': 'Pendiente de conexión',
  'agents.rpa.sessionEndReason.replacedbyanotherinstallation': 'Reemplazada por otro equipo',
  'agents.rpa.sessionEndReason.installationreassigned': 'Equipo reasignado a otro agente',
  'agents.rpa.sessionEndReason.manuallyrevoked': 'Desvinculada manualmente',
  'agents.rpa.sessionEndReason.agentdisabled': 'Agente desactivado',

  // Buttons
  'agents.button.interact': 'Interactuar',
  'agents.button.builder': 'Builder',

  // Form field translations
  'agents.form.provider': 'Proveedor',
  'agents.form.model': 'Modelo',
  'agents.form.connections': 'Conexiones',
  'agents.form.connections.connection': 'Conexión',
  'agents.form.triggers': 'Triggers',
  'agents.form.triggers.hint':
    'Los cambios del draft se guardan solo en la versión. Las suscripciones de Graph se provisionan al publicar.',
  'agents.form.triggers.connectionInUse':
    'Hay una conexión en uso por un trigger. Elimina o reasigna el trigger antes de quitar la conexión.',
  'agents.form.triggers.type': 'Tipo',
  'agents.form.triggers.type.graph-email-received': 'Email recibido (Graph)',
  'agents.form.triggers.type.agent-email-received': 'Email al buzón del agente',
  'agents.form.triggers.type.email-received': 'Email recibido (Graph)',
  'agents.form.triggers.connection': 'Conexión de buzón',
  'agents.form.triggers.connectionId': 'Conexión de buzón',
  'agents.form.triggers.enabled': 'Habilitado',
  'agents.form.triggers.folderId': 'Carpeta',
  'agents.form.triggers.folderId.placeholder': 'Vacío = Inbox',
  'agents.form.triggers.fromFilters': 'Remitentes',
  'agents.form.triggers.fromFilters.placeholder': 'Escribe un email y Enter',
  'agents.form.triggers.subjectFilters': 'Asuntos',
  'agents.form.triggers.subjectFilters.placeholder': 'Escribe un texto y Enter',
  'agents.form.triggers.subjectComparisonOperator': 'Comparación de asunto',
  'agents.form.triggers.subjectComparisonOperator.equal': 'Igual',
  'agents.form.triggers.subjectComparisonOperator.contains': 'Contiene',
  'agents.form.triggers.hasAttachmentsFilter': 'Solo correos con adjuntos',
  'agents.form.triggers.hasAttachmentsFilter.help':
    'Graph solo entrega mensajes que traen archivos adjuntos.',
  'agents.form.triggers.includeAttachments': 'Descargar adjuntos',
  'agents.form.triggers.includeAttachments.help':
    'Si está activo, el agente descarga los adjuntos del correo (no inline) al procesarlo.',
  'agents.form.triggers.onlyAutomyUsers': 'Solo remitentes Automy',
  'agents.form.triggers.onlyAutomyUsers.help':
    'Continúa solo si el remitente coincide con un usuario activo de la compañía.',
  'agents.form.triggers.validateAgentAccess': 'Validar acceso al agente',
  'agents.form.triggers.validateAgentAccess.help':
    'Exige que el remitente Automy tenga permiso para usar este agente. Requiere “Solo remitentes Automy”.',
  'agents.form.triggers.impersonateUser': 'Personificar remitente',
  'agents.form.triggers.impersonateUser.help':
    'Si el remitente es usuario Automy, el chat nuevo queda a su nombre como dueño.',
  'agents.form.triggers.participants': 'Participantes del chat',
  'agents.form.triggers.connection.empty':
    'Agrega una conexión Azure Graph en Conexiones para poder elegir el buzón.',
  'agents.form.triggers.validateAgentAccess.requiresOnlyAutomyUsers':
    'Validar acceso al agente requiere “Solo remitentes Automy”.',
  'agents.form.allowedRoles': 'Configuración de Roles',
  'agents.form.allowedRoles.allowed': 'Roles Permitidos',
  'agents.form.allowedRoles.denied': 'Roles Denegados',
  'agents.form.memory': 'Memoria',
  'agents.form.team': 'Equipo',
  'agents.form.email': 'Correo Electrónico',
  'agents.form.username': 'Usuario',
  'agents.form.domains': 'Dominios',
  'agents.form.longDescription': 'Descripción Larga',
  'agents.form.instructions': 'Instrucciones',
  'agents.form.instructions.edit': 'Editar Instrucciones',
  'agents.form.instructions.placeholder.expanded':
    'Escriba las instrucciones detalladas para su agente de IA...',
  'agents.form.icon': 'Icono',
  'agents.form.isActive': 'Activo',
  'agents.form.deviceName': 'Nombre del Dispositivo',
  'agents.form.ip': 'Dirección IP',
  'agents.form.ip.error': 'Por favor ingrese una dirección IP válida',
  'agents.form.skills': 'Skills',
  'agents.form.skills.skill': 'Skill',
  'agents.form.vectors': 'Vectores',
  'agents.form.vectors.vector': 'Vector',
  'agents.form.collaborators.collaborator': 'Colaborador',

  // Configuration translations
  'agents.form.configurations.greetings': 'Saludos',
  'agents.form.configurations.greetings.message': 'Mensaje',
  'agents.form.configurations.greetings.message.edit': 'Editar Mensaje de Saludo',
  'agents.form.configurations.greetings.message.placeholder':
    'Escriba el mensaje de saludo para este idioma...',
  'agents.form.configurations.searchingHumanAgentMessages': 'Mensajes de Búsqueda de Agente Humano',
  'agents.form.configurations.searchingHumanAgentMessages.message': 'Mensaje',
  'agents.form.configurations.searchingHumanAgentMessages.message.edit':
    'Editar Mensaje de Búsqueda',
  'agents.form.configurations.searchingHumanAgentMessages.message.placeholder':
    'Escriba el mensaje de búsqueda de agente humano para este idioma...',
  'agents.form.configurations.trainingVectors': 'Vectores de Entrenamiento',
  'agents.form.configurations.reasoningEffort': 'Esfuerzo de Razonamiento',
  'agents.form.configurations.reasoningEffort.none': 'Ninguno',
  'agents.form.configurations.reasoningEffort.minimal': 'Mínimo',
  'agents.form.configurations.reasoningEffort.low': 'Bajo',
  'agents.form.configurations.reasoningEffort.medium': 'Medio',
  'agents.form.configurations.reasoningEffort.high': 'Alto',
  'agents.form.configurations.reasoningSummary': 'Resumen de Razonamiento',
  'agents.form.configurations.reasoningSummary.concise': 'Conciso',
  'agents.form.configurations.reasoningSummary.detailed': 'Detallado',
  'agents.form.configurations.reasoningSummary.auto': 'Automático',
  'agents.form.configurations.allowedTools': 'Herramientas Permitidas',
  'agents.form.configurations.allowedTools.codeinterpreter': 'Intérprete de Código',
  'agents.form.configurations.allowedTools.codeinterpreter.description':
    'Ejecuta código Python en un entorno aislado para cálculos, análisis de datos y generación de gráficos.',
  'agents.form.configurations.allowedTools.filesearch': 'Búsqueda de Archivos',
  'agents.form.configurations.allowedTools.filesearch.description':
    'Consulta y recupera información dentro de los archivos cargados al agente.',
  'agents.form.configurations.allowedTools.websearch': 'Búsqueda Web',
  'agents.form.configurations.allowedTools.websearch.description':
    'Busca información actualizada en Internet para responder con datos en tiempo real.',
  'agents.form.configurations.allowedTools.imagegeneration': 'Generación de Imágenes',
  'agents.form.configurations.allowedTools.imagegeneration.description':
    'Crea imágenes a partir de descripciones en lenguaje natural.',
  'agents.form.configurations.allowedTools.mcp': 'MCP',
  'agents.form.configurations.allowedTools.mcp.description':
    'Conecta al agente con servidores MCP externos para acceder a herramientas y fuentes de datos remotas.',
  'agents.form.configurations.allowedTools.function': 'Función',
  'agents.form.configurations.allowedTools.function.description':
    'Permite que el agente invoque funciones personalizadas declaradas por el sistema.',
  'agents.form.configurations.allowedTools.shell': 'Shell',
  'agents.form.configurations.allowedTools.shell.description':
    'Ejecuta comandos de terminal en un entorno controlado para automatizar tareas del sistema.',
  'agents.form.configurations.allowedTools.automyinternalmcp': 'Herramientas Internas',
  'agents.form.configurations.allowedTools.automyinternalmcp.description':
    'Habilita las herramientas internas de Automy: procesos, listas, entidades y acciones de la plataforma.',
  'agents.form.configurations.allowedTools.automyinternalfunctionaitodo': 'Plan ToDo',
  'agents.form.configurations.allowedTools.automyinternalfunctionaitodo.description':
    'Permite que el agente cree ToDos de tareas para planificar y dar seguimiento a operaciones largas, dividiéndolas en pasos.',
  'agents.form.configurations.allowedTools.automyinternalfunctionfileresources':
    'Recursos de Archivos',
  'agents.form.configurations.allowedTools.automyinternalfunctionfileresources.description':
    'Permite que el agente prepare y deje disponibles recursos de archivos para usarlos durante la conversación.',
  'agents.form.configurations.allowedTools.automyinternalfunctionmediaprepareupload':
    'Preparar carga de medios',
  'agents.form.configurations.allowedTools.automyinternalfunctionmediaprepareupload.description':
    'Consolida un archivo ya generado en el intérprete de código como medio durable de Automy y devuelve una URL pública permanente.',
  'agents.form.configurations.guardrails.title': 'Barreras de Seguridad',
  'agents.form.configurations.guardrails.moderation.enabled': 'Opciones de Moderación Habilitadas',
  'agents.form.configurations.guardrails.pii.enabled': 'Opciones de PII Habilitadas',
  'agents.form.configurations.guardrails.pii.rules': 'Reglas de PII',
  'agents.form.configurations.guardrails.pii.rules.entity': 'Entidad',
  'agents.form.configurations.guardrails.pii.rules.entity.creditcard': 'Tarjeta de Crédito',
  'agents.form.configurations.guardrails.pii.rules.entity.email': 'Correo Electrónico',
  'agents.form.configurations.guardrails.pii.rules.entity.phone': 'Teléfono',
  'agents.form.configurations.guardrails.pii.rules.entity.ipaddress': 'Dirección IP',
  'agents.form.configurations.guardrails.pii.rules.entity.ibancode': 'Código IBAN',
  'agents.form.configurations.guardrails.pii.rules.entity.url': 'URL',
  'agents.form.configurations.guardrails.pii.rules.entity.usbanknumber': 'Número de Banco US',
  'agents.form.configurations.guardrails.pii.rules.entity.usitin': 'ITIN US',
  'agents.form.configurations.guardrails.pii.rules.entity.uspassport': 'Pasaporte US',
  'agents.form.configurations.guardrails.pii.rules.entity.usssn': 'SSN US',
  'agents.form.configurations.guardrails.pii.rules.entity.pedni': 'DNI PE',
  'agents.form.configurations.guardrails.pii.rules.entity.peruc': 'RUC PE',
  'agents.form.configurations.guardrails.pii.rules.entity.pepassport': 'Pasaporte PE',
  'agents.form.configurations.guardrails.pii.rules.entity.pebankaccountnumber':
    'Número de Cuenta Bancaria PE',
  'agents.form.configurations.guardrails.pii.rules.entity.pebankaccountcci':
    'CCI Cuenta Bancaria PE',
  'agents.form.configurations.guardrails.pii.rules.action': 'Acción',
  'agents.form.configurations.guardrails.pii.rules.action.mask': 'Enmascarar',
  'agents.form.configurations.guardrails.pii.rules.action.pseudonymize': 'Pseudonimizar',
  'agents.form.configurations.guardrails.pii.rules.action.tokenizereversible':
    'Tokenizar Reversible',
  'agents.form.configurations.guardrails.pii.rules.action.remove': 'Eliminar',
  'agents.form.configurations.guardrails.pii.rules.action.keep': 'Mantener',
  'agents.form.configurations.guardrails.pii.rules.maskChar': 'Carácter de máscara',
  'agents.form.configurations.guardrails.pii.rules.keepPrefix': 'Conservar prefijo',
  'agents.form.configurations.guardrails.pii.rules.keepSuffix': 'Conservar sufijo',
  'agents.form.configurations.guardrails.urlFilter.enabled':
    'Opciones de Filtro de URL Habilitadas',
  'agents.form.configurations.guardrails.urlFilter.action': 'Acción',
  'agents.form.configurations.guardrails.urlFilter.action.block': 'Bloquear',
  'agents.form.configurations.guardrails.urlFilter.action.mask': 'Enmascarar',
  'agents.form.configurations.guardrails.urlFilter.action.warn': 'Advertir',
  'agents.form.configurations.guardrails.urlFilter.mode': 'Modo',
  'agents.form.configurations.guardrails.urlFilter.mode.allowlist': 'Lista de Permitidos',
  'agents.form.configurations.guardrails.urlFilter.mode.denylist': 'Lista de Bloqueados',
  'agents.form.configurations.guardrails.urlFilter.allowedDomains': 'Dominios Permitidos',
  'agents.form.configurations.guardrails.urlFilter.blockedDomains': 'Dominios Bloqueados',
  'agents.form.configurations.guardrails.urlFilter.blockedRegex': 'Patrones Bloqueados (Regex)',
  'agents.form.configurations.guardrails.urlFilter.domain': 'Dominio',
  'agents.form.configurations.guardrails.urlFilter.pattern': 'Patrón',
  'agents.form.configurations.guardrails.urlFilter.allowIpHosts': 'Permitir Hosts IP',
  'agents.form.configurations.guardrails.urlFilter.allowedSchemes': 'Esquemas Permitidos',
  'agents.form.configurations.guardrails.urlFilter.scheme': 'Esquema',
  'agents.form.configurations.guardrails.urlFilter.maxUrls': 'Máximo de URLs',
  'agents.form.configurations.guardrails.urlFilter.blockUrlShorteners':
    'Bloquear Acortadores de URL',
  'agents.form.configurations.guardrails.urlFilter.urlShortenerDomains': 'Dominios de Acortadores',
  'agents.form.configurations.guardrails.jailbreak.enabled': 'Opciones de Jailbreak Habilitadas',
  'agents.form.configurations.guardrails.jailbreak.model': 'Modelo',
  'agents.form.configurations.guardrails.jailbreak.blockConfidence': 'Umbral de Bloqueo',
  'agents.form.configurations.guardrails.pii.title': 'Información personal',
  'agents.form.configurations.guardrails.pii.help':
    'Enmascara o quita datos personales del mensaje antes de que el agente lo lea.',
  'agents.form.configurations.guardrails.urlFilter.title': 'Filtro de URL',
  'agents.form.configurations.guardrails.urlFilter.help':
    'Revisa los enlaces del mensaje antes del resto de controles.',
  'agents.form.configurations.guardrails.moderation.title': 'Moderación',
  'agents.form.configurations.guardrails.moderation.help':
    'Bloquea mensajes que coinciden con las categorías de contenido configuradas.',
  'agents.form.configurations.guardrails.jailbreak.title': 'Jailbreak',
  'agents.form.configurations.guardrails.jailbreak.help':
    'Detecta intentos de saltarse las instrucciones del agente. Se evalúa sobre el texto del mensaje.',
  'agents.form.configurations.guardrails.customPrompt.title': 'Política personalizada',
  'agents.form.configurations.guardrails.customPrompt.help':
    'Marca mensajes que cumplen los criterios que escribas. No es el prompt del agente.',
  'agents.form.configurations.guardrails.customPrompt.enabled': 'Política personalizada',
  'agents.form.configurations.guardrails.customPrompt.criteria': 'Criterios a marcar',
  'agents.form.configurations.guardrails.promptInjection.title': 'Inyección de prompt',
  'agents.form.configurations.guardrails.promptInjection.help':
    'Revisa las acciones propuestas y los resultados de funciones antes de continuar. No es compatible con MCP remoto.',
  'agents.form.configurations.guardrails.promptInjection.enabled': 'Inyección de prompt',
  'agents.form.configurations.guardrails.promptInjection.mcpIncompatible':
    'Prompt Injection no es compatible con MCP remoto',
  'agents.form.configurations.guardrails.hallucination.title': 'Validación documental',
  'agents.form.configurations.guardrails.hallucination.help':
    'Comprueba la respuesta final contra una fuente documental autorizada.',
  'agents.form.configurations.guardrails.hallucination.enabled': 'Validación documental',
  'agents.form.configurations.guardrails.hallucination.vector': 'Fuente documental',
  'agents.form.configurations.guardrails.hallucination.knowledgeSource':
    'Id de vector store de OpenAI',
  'agents.form.configurations.guardrails.llm.model': 'Modelo',
  'agents.form.configurations.guardrails.llm.confidencePercent': 'Umbral de confianza (%)',
  'agents.form.configurations.guardrails.llm.maxTurns': 'Turnos de usuario a revisar',
  'agents.form.configurations.guardrails.llm.includeReasoning':
    'Incluir diagnóstico del clasificador',
  'agents.form.configurations.guardrails.continueOnError': 'Continuar si hay un error',
  'agents.form.configurations.guardrails.continueOnError.help':
    'Si un control de seguridad falla por un error técnico, el turno continúa y el fallo queda visible. Una infracción detectada sigue bloqueando el turno.',
  'agents.form.configurations.guardrails.configure': 'Configurar control',
  'agents.form.configurations.guardrails.validation.hallucinationSource':
    'La validación documental necesita una fuente autorizada',

  // Tabs
  'agents.tabs.general': 'General',
  'agents.tabs.configurations': 'Configuraciones',

  // Wizard steps
  'agents.wizard.steps.basicInformation': 'Información Básica',
  'agents.wizard.steps.technicalConfiguration': 'Configuración Técnica',
  'agents.wizard.steps.permissions': 'Permisos',
  'agents.wizard.steps.advancedConfigurationAndContent': 'Configuración Avanzada y Contenido',
  'agents.wizard.steps.guardrails': 'Guardrails',

  // Global translations
  'global.text.configuration': 'Configuración',

  // Agent Builder
  'agentBuilder.title': 'Nuevo agente',
  'agentBuilder.sidebar.overview': 'Vista general',
  'agentBuilder.token.error.title': 'Configuración versionada no disponible',
  'agentBuilder.token.error.description':
    'No se pudo obtener el token de edición de esta versión. Los cambios en instrucciones, skills, conexiones, permisos, control de acceso, saludos, vectores de entrenamiento y guardrails no podrán guardarse hasta que se restablezca la conexión. Los datos básicos del agente (nombre, modelo, descripción) sí se pueden editar.',
  'agentBuilder.panel.saving': 'Guardando…',
  'agentBuilder.header.openChat': 'Abrir chat',
  'agentBuilder.chat.title': 'Asistente IA',
  'agentBuilder.chat.open': 'Abrir chat',
  'agentBuilder.chat.close': 'Cerrar chat',
  'agentBuilder.error.notFound': 'No se pudo cargar el agente solicitado.',
  'agentBuilder.unsaved.indicator': 'Cambios sin guardar',
  'agentBuilder.unsaved.confirm':
    'Tienes cambios sin guardar. ¿Seguro que quieres salir y descartarlos?',
  'agentBuilder.save.error': 'No se pudieron guardar los cambios del agente.',
  'agentBuilder.card.unnamed': 'Agente sin nombre',
  'agentBuilder.card.noModel': 'Sin modelo',
  'agentBuilder.card.restricted': 'Restringido',
  'agentBuilder.card.itemsCount':
    '{count, plural, =0 {Sin elementos} one {# elemento} other {# elementos}}',
  'agentBuilder.newAgent.title': 'Nuevo agente de IA',
  'agentBuilder.newAgent.subtitle':
    'Define la identidad básica. Completa la configuración en el builder.',
  'agentBuilder.newAgent.continue': 'Continuar',
  'agentBuilder.newAgent.name.placeholder': 'Ej. Asistente de ventas',
  'agentBuilder.newAgent.email.placeholder': 'ventas@agent.automy.global',
  'agentBuilder.newAgent.description.placeholder': '¿Qué hace este agente? ¿A quién ayuda?',
  'agentBuilder.card.active': 'Activo',
  'agentBuilder.card.inactive': 'Inactivo',
  'agentBuilder.card.public': 'Público',
  'agentBuilder.card.private': 'Privado',
  'agentBuilder.card.configure': 'Configurar',
  'agentBuilder.card.empty': 'Sin configurar',
  'agentBuilder.card.configured': 'Configurado',
  'agentBuilder.card.stats.permissions':
    '{count, plural, =0 {Sin permisos} one {# permiso} other {# permisos}}',
  'agentBuilder.card.stats.greetings':
    '{count, plural, =0 {Sin mensajes} one {# saludo} other {# saludos}}',
  'agentBuilder.card.stats.guardrails':
    '{count, plural, =0 {Sin guardrails} one {# guardrail activo} other {# guardrails activos}}',
  'agentBuilder.card.stats.skills':
    '{count, plural, =0 {Sin habilidades} one {# habilidad} other {# habilidades}}',
  'agentBuilder.card.stats.connections':
    '{count, plural, =0 {Sin conexiones} one {# conexión} other {# conexiones}}',
  'agentBuilder.card.stats.triggers':
    '{count, plural, =0 {Sin triggers} one {# trigger} other {# triggers}}',
  'agentBuilder.card.stats.escalations':
    '{count, plural, =0 {Sin escalaciones} one {# escalación} other {# escalaciones}}',
  'agentBuilder.card.stats.guardrailsRatio': '{active}/{total} activos',
  'agentBuilder.card.noDescription':
    'Agrega una descripción para que tu equipo sepa cómo usar este agente.',
  'agentBuilder.section.general': 'General',
  'agentBuilder.section.brain': 'Cerebro',
  'agentBuilder.section.brain.subtitle':
    'Define la inteligencia central del agente: instrucciones, conocimiento y herramientas que utiliza para razonar.',
  'agentBuilder.instructions.title': 'Instrucciones del sistema',
  'agentBuilder.instructions.subtitle':
    'Indícale al agente quién es, qué debe hacer y cómo comportarse.',
  'agentBuilder.instructions.placeholder':
    'Eres un asistente útil que…\n\nDescribe el rol del agente, sus objetivos, el tono que debe usar y cualquier regla o restricción que deba seguir.',
  'agentBuilder.instructions.words': '{count} palabras',
  'agentBuilder.instructions.chars': '{count} caracteres',
  'agentBuilder.instructions.expand': 'Ampliar editor',
  'agentBuilder.instructions.done': 'Listo',
  'agentBuilder.instructions.template': 'Insertar plantilla',
  'agentBuilder.instructions.toolbarLabel': 'Estructura',
  'agentBuilder.instructions.hint':
    'Sé específico: define el rol, los objetivos y las restricciones. Unas buenas instrucciones mejoran notablemente las respuestas.',
  'agentBuilder.instructions.section.role': 'Rol y objetivo',
  'agentBuilder.instructions.section.context': 'Contexto',
  'agentBuilder.instructions.section.instructions': 'Instrucciones',
  'agentBuilder.instructions.section.constraints': 'Restricciones',
  'agentBuilder.instructions.section.tone': 'Tono y estilo',
  'agentBuilder.instructions.section.format': 'Formato de salida',
  'agentBuilder.instructions.tipsTitle': 'Consejos para escribir buenas instrucciones',
  'agentBuilder.instructions.tip1':
    'Empieza definiendo el rol del agente y su objetivo principal en una frase clara.',
  'agentBuilder.instructions.tip2':
    'Divide las indicaciones en secciones cortas y usa listas para los pasos o reglas.',
  'agentBuilder.instructions.tip3':
    'Indica explícitamente lo que NO debe hacer y cómo manejar los casos ambiguos.',
  'agentBuilder.instructions.tip4':
    'Especifica el tono, el idioma y el formato de salida esperado (texto, lista, JSON…).',
  'agentBuilder.card.reasoning.summary.placeholder': 'Sin resumen',
  'agentBuilder.card.reasoning.effort.short': 'Esfuerzo',
  'agentBuilder.card.reasoning.summary.short': 'Resumen',
  'agentBuilder.section.permissions': 'Permisos',
  'agentBuilder.section.behavior': 'Conducta',
  'agentBuilder.section.guardrails': 'Guardrails',
  'agentBuilder.card.trainingDocs': 'Documentos de entrenamiento',
  'agentBuilder.card.stats.trainingDocs':
    '{count, plural, =0 {Sin documentos} one {# documento} other {# documentos}}',

  // Versions & publish (versioned config flow)
  'agentBuilder.version.createdBy': 'Creado por',
  'agentBuilder.version.createdDate': 'Fecha de creación',
  'agentBuilder.version.publishedBy': 'Publicado por',
  'agentBuilder.version.publishedDate': 'Fecha de publicación',
  'agentBuilder.version.current': 'actual',
  'agentBuilder.version.error': 'No se pudo cambiar a la versión seleccionada.',
  'agentBuilder.publish': 'Publicar',
  'agentBuilder.published': 'Publicada',
  'agentBuilder.publish.success': 'Versión publicada correctamente.',
  'agentBuilder.publish.error': 'No se pudo publicar la versión.',
  'agentBuilder.publish.forceButton': 'Publicar de todos modos',
  'agentBuilder.publish.inconsistencies.title': 'Revisar advertencias antes de publicar',
  'agentBuilder.publish.inconsistencies.intro':
    'El agente se puede publicar, pero el resumen interno detectó problemas que pueden afectar el enrutamiento de herramientas y recursos en el chat.',
  'agentBuilder.publish.inconsistencies.hint':
    'Si publicas de todos modos, el orquestador puede enrutar herramientas o recursos de forma subóptima hasta que corrijas la configuración y vuelvas a publicar.',
  'agentBuilder.setCurrent': 'Establecer actual',
  'agentBuilder.setCurrent.success': 'Versión establecida como actual exitosamente.',
  'agentBuilder.setCurrent.error': 'Error al establecer la versión como actual.',
  'agentBuilder.setCurrent.tooltip':
    'Esta versión publicada pasará a ser la que usa el agente en producción.',
  'agentBuilder.publish.tooltip.readOnly':
    'Esta versión ya está publicada. Cambia a una versión en borrador para editar.',
  'agentBuilder.readonly.cantEdit': 'No se puede editar una versión publicada.',
  // Access Control card summary
  'agentBuilder.card.accessControl.public': 'Visible para todos',
  'agentBuilder.card.accessControl.restricted':
    '{count, plural, =0 {Sin acceso configurado} one {Acceso restringido (# entidad)} other {Acceso restringido (# entidades)}}',

  // Sidebar entries
  'agentBuilder.sidebar.traces': 'Trazas',
  'agentBuilder.sidebar.dependencies': 'Dependencias',

  // Traces
  'agentBuilder.traces.title': 'Trazas de configuración',
  'agentBuilder.traces.empty': 'Aún no hay trazas para esta versión.',
  'agentBuilder.traces.column.operation': 'Operación',
  'agentBuilder.traces.column.elementType': 'Elemento',
  'agentBuilder.traces.column.creator': 'Usuario',
  'agentBuilder.traces.column.created': 'Fecha',
  'agentBuilder.traces.column.data': 'Detalle',
  'agentBuilder.traces.operation.generate-token-readonly': 'Token lectura',
  'agentBuilder.traces.operation.generate-token-write': 'Token edición',
  'agentBuilder.traces.operation.append-component': 'Agregar componente',
  'agentBuilder.traces.operation.modify-component': 'Modificar componente',
  'agentBuilder.traces.operation.remove-component': 'Eliminar componente',
  'agentBuilder.traces.operation.publish': 'Publicar',
  'agentBuilder.traces.operation.new-version-created': 'Nueva versión',
  'agentBuilder.traces.operation.change-current-version': 'Cambiar versión actual',

  // Dependencies
  'agentBuilder.dependencies.title': 'Dependencias',
  'agentBuilder.dependencies.empty':
    'Este agente no tiene dependencias declaradas en su configuración actual.',
  'agentBuilder.dependencies.column.entity': 'Entidad',
  'agentBuilder.dependencies.column.type': 'Tipo',
  'agentBuilder.dependencies.column.name': 'Nombre',

  // EntitySelector keys live in src/locales/{lang}/component.js (shared globally)
};
